import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission, formatDate } from '../../../sc-utilities';
import ContactList from './ContactList';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const Contact = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, contactID: null, redirectPath: '' });
    const redirectHandler = (path, contactID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, contactID: contactID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    let visible = columns && columns['Contact'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'contact_load') ? <Tooltip title={translations["contact_details"] || "Contact details"}>
                        <IconButton
                            id={`edit_contact_${rowData.ContactID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/contact/edit?contactID=${rowData.ContactID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                        : null
                }
            </>
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Type ? rowData.Type : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["first_name"] || 'First name', field: 'FirstName',
            hidden: visible ? visible['FirstName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FirstName ? rowData.FirstName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["last_name"] || 'Last name', field: 'LastName',
            hidden: visible ? visible['LastName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.LastName ? rowData.LastName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["company_name"] || 'Company name', field: 'CompanyName',
            hidden: visible ? visible['CompanyName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CompanyName ? rowData.CompanyName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["phone_number"] || 'Phone number', field: 'PhoneNumber',
            hidden: visible ? visible['PhoneNumber'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.PhoneNumber ? rowData.PhoneNumber : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["email"] || 'Email', field: 'Email',
            hidden: visible ? visible['Email'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Email ? rowData.Email : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["created_at"] || 'Created at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            filtering: true,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, ['contact_load'])) {
        tableColumns.shift();
    };

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'contact_list') ?
                <ContactList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(Contact));